// extracted by mini-css-extract-plugin
export default {"button":"Contact_button__vfEM2","svg-wrapper":"Contact_svg-wrapper__oLksC","fly-1":"Contact_fly-1__yyRPh"};